
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[id]",
      function () {
        return require("private-next-pages/categories/[id].js");
      }
    ]);
  